import React from "react";
import { colours } from "styling/colours";
import { classes, style } from "typestyle";

type TextButtonProps = {
  title?: string;
  onClick: () => void;
  disabled?: boolean;
  secondary?: boolean;
  children: React.ReactNode | string;
  className?: string;
  withoutHoverClass?: boolean;
  decoration?: boolean;
  id?: string;
};

const TextButton = React.forwardRef<HTMLButtonElement, TextButtonProps>((props, ref) => {
  const {
    className,
    disabled,
    title,
    onClick,
    secondary,
    children,
    id = `${title}-btn`,
    withoutHoverClass,
    decoration = false
  } = props
  return (
    <button
      className={classes(linkStyle(secondary, disabled, withoutHoverClass, decoration), className)}
      title={title}
      onClick={onClick}
      disabled={disabled}
      id={id}
    >
      {children}
    </button>
  );
});

const linkStyle = (secondary = false, disabled = false, withoutHoverClass = false, decoration = false) =>
  style({
    textDecoration: disabled || !decoration ? "none" : "underline",
    color: disabled
      ? colours.secondaryText
      : secondary
        ? colours.link
        : colours.primaryText,
    border: "none",
    backgroundColor: "inherit",
    padding: "12px 11px",
    cursor: disabled ? undefined : "pointer",
    $nest: {
      "&:hover": withoutHoverClass ? {} : {
        background: disabled ? undefined : colours.background,
        color: disabled
          ? colours.secondaryText
          : colours.secondary,
      },
      "&:focus": {
        outline: `1px solid ${colours.secondary}`,
        outlineOffset: "-1px"
      }
    },
  });

export default TextButton;
